import { authFormReducer } from '../../authForm/reducers/AuthFormReducer';
import authFormSaga from '../../authForm/sagas/AuthFormSaga';
const loadAuthenticationFormModule = () => ({
    id: 'AuthenticationForm',
    reducerMap: {
        authForm: authFormReducer,
    },
    sagas: [authFormSaga],
});
export default loadAuthenticationFormModule;
